import axios from "axios";

const BASE_URL = "https://sorteos.diferente.es/api/sorteosdiferentefront"; // Cambiar a https cuando est� listo

const axiosApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        "X-CLAVE-SECRETA": "cb493299-0b90-4be6-ac29-c5e7eb3430ba",
    },
});

const getSorteoActivo = async () => {
    const response = await axiosApi.get("/sorteos");
    const data = response?.data;

    if (data && typeof data === "object" && !Array.isArray(data)) {
        if (Object.keys(data).length > 0) {
            return { ok: true, data };
        }
        return false;
    }

    return false;
};
const verificarTicket = async (serie, numero, importe) => {
    const response = await axiosApi.post("/verificarticket", {
        serie: serie,
        numero: numero,
        importe: importe,
    });
    console.log(response);
    const data = response?.data;

    return data;
};

const enviarDatosSorteo = async (
    nombre,
    apellidos,
    Email,
    telefono,
    aceptaPrivacidad,
    aceptaComunicaciones,
    idtick,
) => {
    try {
        const response = await axiosApi.post("/asignarticket", {
            nombre: nombre,
            apellidos: apellidos,
            email: Email,
            telefono: telefono,
            aceptaPrivacidad: aceptaPrivacidad,
            aceptaComunicaciones: aceptaComunicaciones,
            idtick: idtick,
        });

        return { ok: true, status: response?.status, data: response?.data };
    } catch (error) {
        console.log(error);
        if (error?.response?.status === 409) {
            console.log(error);
            return {
                ok: false,
                status: 409,
                mensaje:
                    error?.response?.data?.mensaje ||
                    "Ya existe una solicitud para este ticket.",
            };
        }
        throw error;
    }
};

export {
    axiosApi,
    BASE_URL,
    getSorteoActivo,
    verificarTicket,
    enviarDatosSorteo,
};
